import { marketplacePreviewAxiosInstance } from '@/apis/marketplace-preview/requests'
import Badge from '@/app/common/components/Badge'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

export default function MarketplacePreviewLayout() {
  const searchParams = new URLSearchParams(location.search)
  const { t: translate } = useTranslation()
  const [tokenStatus, setTokenStatus] = useState<
    'loading' | 'success' | 'error'
  >('loading')

  function removeAccessTokenFromUrl() {
    const url = new URL(window.location.href)
    url.searchParams.delete('token')
    window.history.replaceState({}, '', url.toString())
  }

  useEffect(() => {
    setTokenStatus('loading')
    const previewToken = searchParams.get('token')

    if (previewToken) {
      marketplacePreviewAxiosInstance.defaults.headers.common.Authorization = `Bearer ${previewToken}`
      sessionStorage.setItem('previewToken', previewToken)
      setTokenStatus('success')
    } else {
      const backupToken = sessionStorage.getItem('previewToken')
      if (backupToken) {
        marketplacePreviewAxiosInstance.defaults.headers.common.Authorization = `Bearer ${backupToken}`
        setTokenStatus('success')
      } else {
        setTokenStatus('error')
      }
    }
    removeAccessTokenFromUrl()
  }, [])

  if (tokenStatus === 'loading') {
    return null
  }

  if (tokenStatus === 'error') {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-center text-red-500 text-lg">
          {translate("You don't have permission to access this page")}
        </p>
      </div>
    )
  }

  return (
    <div className="max-w-screen-2xl w-full mx-auto pt-20">
      <div className="py-8">
        <Badge semanticColor="Positive">Store Preview</Badge>
      </div>
      <Outlet />
    </div>
  )
}
